import { ArrowDownAz, ArrowDownUp, ArrowDownZa } from "lucide-react";

/** Lucide glyphs aligned with `SortButton`: A→Z for ascending, Z→A for descending, neutral when idle. */
export const ActiveFiltersBarSortStatusIcon = ({
  sortDirection,
  className,
}: {
  sortDirection: "asc" | "desc" | null;
  className: string;
}) => {
  if (sortDirection === "asc") {
    return <ArrowDownAz className={className} />;
  }
  if (sortDirection === "desc") {
    return <ArrowDownZa className={className} />;
  }
  return <ArrowDownUp className={className} />;
};
